import React, { useState, useEffect } from 'react';
import useTranslation from '../../hooks/useTranslation';
import useSelectedDeck from '../../hooks/useSelectedDeck';
import ContentAddQuiz from '../../components/ContentAdd/ContentAddQuiz';
import { message } from "antd";
import ContentAddWord from "../../components/ContentAdd/ContentAddWord";
import ContentAddCard from "../../components/ContentAdd/ContentAddCard"; // Добавляем message для уведомлений

const ContentPage = () => {
    const { t } = useTranslation();
    const [selectedType, setSelectedType] = useState('');

    // Получаем selectedDeck из Redux
    const selectedDeck = useSelectedDeck();
    // Обновляем selectedType при изменении selectedDeck
    useEffect(() => {
        if (selectedDeck) {
            if (selectedDeck.type) {
                setSelectedType(selectedDeck.type);
            } else {
                setSelectedType('');
                message.warning(t('deck.noType'));
            }
        } else {
            setSelectedType('');
        }
        // t в зависимостях: react-i18next пересоздаёт его при смене языка, и предупреждение
        // должно уйти на языке, выбранном сейчас
    }, [selectedDeck, t]);

    const renderContentForm = () => {
        switch (selectedType) {
            case 'QUIZ':
                return <ContentAddQuiz />;
            case 'CARD':
                return <ContentAddCard />;
            case 'WORD':
                return <ContentAddWord />;
            // Будущие случаи для других типов
            default:
                return <div>{t('deck.selectValidType')}</div>;
        }
    };

    // Спиннера здесь нет намеренно: страница ничего не грузит с сервера,
    // формы добавления показывают loading только на своём submit.
    return (
        <div style={{ width: '100%' }}>
            <div style={{ marginTop: '10px', width: '100%' }}>
                {selectedDeck ? renderContentForm() : <div>{t('deck.selectToViewContent')}</div>}
            </div>
        </div>
    );
};

export default ContentPage;
